var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en_GB/phone_number/index.js
// module id = 2727
// module chunks = 1610